import * as React from 'react';
import { useEffect } from 'react';
import { createBlobService } from 'utils/factories';
import { environment } from 'env';
import { useNavigate, useParams } from 'react-router-dom';
import { CircularProgress, Typography } from '@mui/material';
import { toast } from 'react-toastify';


export default function ExportCatalogsContainer() {

    const { id } = useParams();
    const navigate = useNavigate();

    const loadingText = "Downloading..."


    useEffect(() => {
        const BACKEND_URI = environment.REACT_APP_API_BASE ?? "http://localhost:3000";
        const url = BACKEND_URI + '/api/download/GetExportPsl' + `?id=${id}`;

        createBlobService(url, "GET")().then(
            (blob) => {
                const url = URL.createObjectURL(blob);
                const downloadLink = document.createElement("a");
                downloadLink.href = url;
                downloadLink.download = id;
                document.body.appendChild(downloadLink);
                downloadLink.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(downloadLink);
                navigate('/');
                toast.success("Downloaded successfully");
            }
        )
    });

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100%',
            minHeight: '300px',
            position: 'relative'
        }}>
            <CircularProgress size={50} />
            <div style={{ marginTop: "10px", fontWeight: "bolder", fontSize: "10px" }}><Typography variant="caption">{loadingText}</Typography></div>
        </div>
    )
};
